import React from 'react';
import { Redirect, RouteComponentProps } from "react-router-dom";
import { Box, Link, Flex, Text, VStack } from "@chakra-ui/react";
import { LoginForm } from "./LoginForm";
import { ReactComponent as Logo } from "assets/logo.svg";
import { ReactComponent as CBHLogo } from "assets/cbh_logo.svg";
import { isLogin } from "utils/auth";
import { Card, FormWrapper } from "components";
import { BasicLayout } from "layouts";
import qs from "qs";
import { isFuture, isPast } from 'date-fns';
import { ReactComponent as Ornaments } from "assets/ornaments.svg";

const Login: React.FC<RouteComponentProps> = (props: RouteComponentProps) => {
  if (isLogin()) return <Redirect push to="/" />;

  const queryParams = qs.parse(props.location.search, {
    ignoreQueryPrefix: true
  });

  const toPath = queryParams["to"] ?? "/";

  //update the lines below based on yearly winter break timeframe
  const isWinterBreak = isPast(new Date(2025, 11, 19, 16, 30)) && isFuture(new Date(2026, 0, 5, 8));
  const newYearLine1 = `The Charisma Support Team is out until Jan. 5th.`
  const newYearLine2 = `Support will be limited. Please check our FAQ for assistance. Happy holidays and see you in 2026!`

  //change the variable below depending on whether there's an issue or not
  const isIssue = false;
  const issueLine1 = "We are currently facing server issues impacting service performance.";
  const issueLine2 = "Our team is actively resolving the issue. Apologies for any inconvenience caused.";
  const issueLine3 = "If you encounter problems, please cancel your session within 15 minutes of the session start."

  return (
    <BasicLayout showBackgroundImage>
      <VStack maxWidth="100%" align="center">
        {isWinterBreak &&
          <Box
            mt="-25px"
            mb="150px"
          >
            <Flex>
              <Card w="850px" p={0}>
                <Flex dir="row">
                  <VStack align="left" ml={8} mt={8} mb={8} spacing={0} w="1450px">
                    <Text textAlign="left" fontWeight="bold" fontSize="20px">{newYearLine1}</Text>
                    <Text textAlign="left" fontSize="20px" w="auto">{newYearLine2}</Text>
                  </VStack>
                  <Ornaments width="80%"/>
                </Flex>  
              </Card>
            </Flex>
          </Box>
        }
        {isIssue &&
          <Box
            mt="-25px"
            mb="150px"
          >
            <Flex>
              <Card w="850px" p={0}>
                <Flex dir="row">
                  <VStack align="left" ml={8} mt={8} mb={8} mr={8} spacing={0} w="1200px">
                    <Text textAlign="left" fontWeight="bold" fontSize="20px">{issueLine1}</Text>
                    <Text textAlign="left" fontSize="20px">{issueLine2}</Text>
                    <Text textAlign="left" fontSize="20px">{issueLine3}</Text>
                  </VStack>
                </Flex>  
              </Card>
            </Flex>
          </Box>
        }
        <Box>
          <FormWrapper
            aboveForm={
              <Box maxW="300px" margin="0 auto">
                <Logo width="100%" />
              </Box>
            }
            form={<LoginForm toPath={toPath} />}
            belowForm={
              <Box textAlign="center" color="gray.200">
                <Link
                  href={`${process.env.REACT_APP_PORTAL_URL}/forgot-password`}
                >
                  Can&apos;t log in?
                </Link>
              </Box>
            }
          />
          <Box
            h="63px"
            position={["relative", "fixed"]}
            bottom={[null, 8]}
            m={["0 auto", null]}
            mt={4}
            left={[null, 8]}
          >
            <CBHLogo width="100%" height="100%" />
          </Box>
        </Box>
      </VStack>
    </BasicLayout>
  );
};

export default Login;
